export function sumDeliverableRowsByMonth(rows, columns, aggregateField) {
	return columns.map(column => {
		if (!column.startDate) {
			const total = rows.reduce((sum, row) => sum + (row.financialNumbers[aggregateField] || 0), 0);
			return {startDate: null, value: total};
		}
		const year = column.startDate.year();
		const month = column.startDate.month() + 1;
		const total = rows
			.filter(row => row.year === year && row.month === month)
			.reduce((sum, row) => sum + (row.financialNumbers[aggregateField] || 0), 0);
		return {startDate: column.startDate, value: total};
	});
}

export function groupDeliverableRowsById(rows, columns, aggregateField, allDeliverableIds, currency) {
	const rowsByDeliverableId = {};
	rows.forEach(row => {
		if (!rowsByDeliverableId[row.deliverableId]) {
			rowsByDeliverableId[row.deliverableId] = [];
		}
		rowsByDeliverableId[row.deliverableId].push(row);
	});
	return allDeliverableIds.map(deliverableId => ({
		deliverableId,
		currency,
		dataArray: sumDeliverableRowsByMonth(rowsByDeliverableId[deliverableId] || [], columns, aggregateField),
	}));
}

export function sumDataArrays(a, b) {
	return a.map((entry, index) => ({startDate: entry.startDate, value: entry.value + b[index].value}));
}

export function buildTimeAndMaterialsRow({columns, timeRows, expenseRows, currency}) {
	const timeAndMaterialsTime = sumDeliverableRowsByMonth(timeRows, columns, 'recognitionAmount');
	// Expenses don't get the time-based recognition proration - both the already-incurred and
	// still-forecast portions are booked as fully recognized the moment they exist (ExpenseLogic.ts /
	// DeliverableFixedFeeLogic.ts's applyExpenseRevenueAsIs), so recognitionAmount and
	// billableTotalTimeAndExpensesAtCompletion are the same figure for expense-role rows. Using the
	// at-completion field here matches the pre-existing "Expenses" row above, so both reconcile.
	const timeAndMaterialsExpenses = sumDeliverableRowsByMonth(
		expenseRows,
		columns,
		'billableTotalTimeAndExpensesAtCompletion'
	);

	return {
		aggregate: 'timeAndMaterials',
		currency,
		dataArray: sumDataArrays(timeAndMaterialsTime, timeAndMaterialsExpenses),
		children: [
			{aggregate: 'timeAndMaterialsTime', currency, dataArray: timeAndMaterialsTime},
			{aggregate: 'timeAndMaterialsExpenses', currency, dataArray: timeAndMaterialsExpenses},
		],
	};
}

export function buildFixedPriceDeliverablesRow({
	columns,
	totalTimeRows,
	totalExpenseRows,
	perDeliverableTimeRows,
	perDeliverableExpenseRows,
	allDeliverableIds,
	currency,
}) {
	const fixedPriceDeliverablesTime = sumDeliverableRowsByMonth(totalTimeRows, columns, 'recognitionAmount');
	// See buildTimeAndMaterialsRow above: expenses don't get time's recognition proration, so
	// billableTotalTimeAndExpensesAtCompletion is the recognized figure for expense-role rows.
	const fixedPriceDeliverablesExpenses = sumDeliverableRowsByMonth(
		totalExpenseRows,
		columns,
		'billableTotalTimeAndExpensesAtCompletion'
	);

	return {
		aggregate: 'fixedPriceDeliverables',
		currency,
		dataArray: sumDataArrays(fixedPriceDeliverablesTime, fixedPriceDeliverablesExpenses),
		children: [
			{
				aggregate: 'fixedPriceDeliverablesTime',
				currency,
				dataArray: fixedPriceDeliverablesTime,
				deliverables: groupDeliverableRowsById(
					perDeliverableTimeRows,
					columns,
					'recognitionAmount',
					allDeliverableIds,
					currency
				),
			},
			{
				aggregate: 'fixedPriceDeliverablesExpenses',
				currency,
				dataArray: fixedPriceDeliverablesExpenses,
				deliverables: groupDeliverableRowsById(
					perDeliverableExpenseRows,
					columns,
					'billableTotalTimeAndExpensesAtCompletion',
					allDeliverableIds,
					currency
				),
			},
		],
	};
}
